import styled from 'styled-components';
import { breakpoints, colors } from '../../constants';

interface IProps {
    secondary?: boolean;
}

export const Button = styled.button.attrs(() => ({
    type: 'button',
}))<IProps>`
    appearance: none;
    border: 0;
    height: 48px;
    padding: 0 16px;
    font-size: 1rem;
    background-color: ${({ secondary }) =>
        secondary ? 'transparent' : colors.greenPrimary};
    color: ${({ secondary }) => (secondary ? colors.black : colors.white)};
    border: ${({ secondary }) => secondary && `1px solid ${colors.black}`};
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.2s linear;
    width: 100%;
    min-width: 120px;

    @media (${breakpoints.mediumMin}) {
        width: fit-content;
        color: ${colors.black};
        background-color: ${({ secondary }) =>
            secondary ? 'transparent' : colors.white};
        border: ${({ secondary }) => secondary && `1px solid ${colors.white}`};

        :hover {
            text-decoration: none;
            background-color: ${({ secondary }) =>
                secondary ? colors.white : colors.greenLightMedium};
        }
    }
`;
